module.exports = {"410329100":"城关镇","410329101":"鸣皋镇","410329102":"水寨镇","410329103":"彭婆镇","410329104":"白沙镇","410329105":"江左镇","410329106":"高山镇","410329107":"吕店镇","410329108":"半坡镇","410329109":"酒后镇","410329110":"白元镇","410329200":"鸦岭乡","410329203":"平等乡","410329205":"葛寨乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410329.json
// module id = 1424
// module chunks = 0